import React from "react";
import QTextBox from "../../../../common/components/QTextBox";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {config} from "../../../../config";
import {Col, Row} from "reactstrap";
import {Formik} from "formik";
import * as yup from "yup";
import QButton from "../../../../common/components/QButton";
import {useDispatch} from "react-redux";
import {setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import {SetupInterface} from "../../../../interfaces/private/SetupInterface";
import {useTranslation} from "react-i18next";

interface Props {
    model: SetupInterface,
    setOpen: (open: boolean) => void,
    setLoadingFunc: (loading: boolean) => void,
    setSetup: (setup: SetupInterface) => void,
    onSuccess?: () => void,
}

const validationSchema = yup.object({
    economic_token: yup.string().required("Token is required"),
});

const BodyEconomicComponent: React.FC<Props> = ({
    model,
    setOpen,
    setLoadingFunc,
    setSetup,
    onSuccess,
}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    return (
        <Formik
            initialValues={{economic_token: model.economic_token || ""}}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                SetupApi.update(values).then(async (response: ResponseInterface | any) => {
                    if (response.status === config.STATUS_CODE.OK) {
                        setSetup(response?.data?.data || {});
                        await setOpen(false);
                        await setLoadingFunc(true);
                        onSuccess?.();
                        dispatch(setToast({
                            message: t("economic.manualUpdateSuccess"),
                            type: config.TOAST_TYPE.SUCCESS,
                        }));
                    } else {
                        dispatch(setToast({
                            message: response?.data?.message || t("economic.manualUpdateError"),
                            type: config.TOAST_TYPE.ERROR,
                        }));
                    }
                }).catch((error: any) => {
                    dispatch(setToast({
                        message: error?.data?.message || t("economic.manualUpdateError"),
                        type: config.TOAST_TYPE.ERROR,
                    }));
                });
            }}
        >
            {formik => (
                <React.Fragment>
                    <p className="text-muted mb-3">{t("economic.manualUpdateHelp")}</p>
                    <Row>
                        <Col>
                            <QTextBox
                                label={t("economic.token")}
                                value={formik.values.economic_token}
                                onChange={(value: string) => {
                                    formik.setFieldValue("economic_token", value);
                                }}
                                error={formik.touched.economic_token && formik.errors.economic_token
                                    ? String(formik.errors.economic_token)
                                    : undefined}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <QButton
                                    type="default"
                                    onClick={() => setOpen(false)}
                                    content={t("common.button.cancel")}
                                />
                                <QButton
                                    type="primary"
                                    onClick={() => formik.handleSubmit()}
                                    content={t("common.button.submit")}
                                />
                            </div>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </Formik>
    );
};

export default BodyEconomicComponent;
